import React from 'react';
import { COLORS } from '../utils/constants';

export default function CircularProgress({ value, max, color, size = 80, strokeWidth = 7, label, sublabel, overflowPct = 0 }) {
  const r = (size - strokeWidth * 2) / 2;
  const circ = 2 * Math.PI * r;
  const pct = Math.min(value / max, 1);
  const offset = circ - pct * circ;

  // Anillo de desbordamiento: radio más pequeño, trazo más grueso, encima del original
  const ovStroke = strokeWidth + 4;
  const rOv = (size - ovStroke * 2) / 2;
  const circOv = 2 * Math.PI * rOv;
  const ovOffset = circOv - Math.min(overflowPct, 1) * circOv;

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 4 }}>
      <svg width={size} height={size}>
        {/* Pista de fondo */}
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={COLORS.border} strokeWidth={strokeWidth} opacity={0.3} strokeLinecap="round" />
        {/* Progreso principal */}
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={color} strokeWidth={strokeWidth}
          strokeDasharray={circ} strokeDashoffset={offset} strokeLinecap="round"
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
          style={{ transition: "stroke-dashoffset 0.8s ease" }} />
        {/* Segundo anillo (exceso) */}
        {overflowPct > 0 && (
          <circle cx={size / 2} cy={size / 2} r={rOv} fill="none" stroke={color} strokeWidth={ovStroke}
            strokeDasharray={circOv} strokeDashoffset={ovOffset} strokeLinecap="round"
            transform={`rotate(-90 ${size / 2} ${size / 2})`}
            style={{ transition: "stroke-dashoffset 0.8s ease" }} opacity={0.85} />
        )}
        <text x="50%" y="50%" textAnchor="middle" dy="0.35em"
          fill="#fff" fontSize={size * 0.22} fontWeight="900" fontFamily="'Plus Jakarta Sans', sans-serif">{value}</text>
      </svg>
      {label && <span style={{ color: "rgba(255,255,255,0.9)", fontSize: 12, fontWeight: 800, fontFamily: "'Plus Jakarta Sans', sans-serif", letterSpacing: 0.5 }}>{label}</span>}
      {sublabel && <span style={{ color: "rgba(255,255,255,0.5)", fontSize: 10, fontWeight: 700, fontFamily: "'Plus Jakarta Sans', sans-serif" }}>/{max}{sublabel}</span>}
    </div>
  );
}
